import { render, staticRenderFns } from "./devicg.vue?vue&type=template&id=9d4a3d48&scoped=true&"
import script from "./devicg.vue?vue&type=script&lang=js&"
export * from "./devicg.vue?vue&type=script&lang=js&"
import style0 from "./devicg.vue?vue&type=style&index=0&id=9d4a3d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4a3d48",
  null
  
)

export default component.exports